<template>
    <div class="layout-column-ittem-warpper" :style="styleObj">
      <!-- {{config}} -->
      <slot>
          <h3>{{config}}</h3>
      </slot>
    </div>
</template>
<style lang="less">
    .layout-column-ittem-warpper{
      overflow: auto;
    }
</style>
<script>
export default {
    props: [
    'config'
  ],
  computed:{
    styleObj(){
      let height, width, overflowX, overflowY;
      if(this.config&&this.config.slotInfo&&this.config.slotInfo.position){
        let pos = this.config.slotInfo.position;
        if(pos.height){
          height = pos.height.value+pos.height.unit;
        }
        if(pos.width){
          width = pos.width.value+pos.width.unit;
        }
        if(pos.hideOverflowX){
          overflowX = 'hidden';
        }
        if(pos.hideOverflowY){
          overflowY = 'hidden';
        }
      }else{
        this.config.slotInfo = {
          belongLayout:"de-layout-overflow",
          position:{
            height:{unit:"%", value:100},
          width:{unit:"%", value:100}
          }
        }
      }
      return {
        height, width,overflowX, overflowY
      }
    }
  }
}
</script>